import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import useSWRMutation from "swr/mutation";
import type { WorkflowResourceType } from "~/models/CompanyWorkflowSetting";
import { WORKFLOW_LOCK_TARGET_LABEL } from "~/models/CompanyWorkflowSetting";
import { isSuccess } from "~/utils/api/api_handler";
import { unlock } from "~/utils/api/deals/DealConstructionWorkflowLock";
import { generatePath } from "~/utils/generatePath";

type Props = {
	dealId: number;
	handleClose: () => void;
	resourceType: WorkflowResourceType;
};

export function WorkflowLockUnlockModal({
	dealId,
	handleClose,
	resourceType
}: Props) {
	const { notify } = useNotification();
	const { trigger, isMutating } = useSWRMutation(
		generatePath("/deals/:deal_id/deal_workflow_restriction", {
			deal_id: dealId
		}),
		async () => unlock(dealId, resourceType)
	);

	const onClickUnlock = async (): Promise<void> => {
		const result = await trigger();
		if (isSuccess(result)) {
			notify({ content: "編集ロックを解除しました。", variant: "success" });
			handleClose();
		} else {
			notify({
				content: result.message ?? "編集ロックの解除に失敗しました。",
				variant: "error"
			});
		}
	};

	return (
		<Modalv2 isOpen onClose={handleClose}>
			<ModalHeader title="編集ロックの解除" />
			<ModalBody>
				<Paragraph>
					{`${WORKFLOW_LOCK_TARGET_LABEL[resourceType]}を編集できるようにします。編集した場合、ワークフロー開始時の内容とは異なるため、再度ワークフローを開始してください。`}
					<br />
					ロック解除の日時と操作者名はこの案件の履歴画面に記録されます。
				</Paragraph>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Buttonv2
						disabled={isMutating}
						onClick={handleClose}
						variant="secondary"
					>
						キャンセル
					</Buttonv2>
				}
				rightArea={
					<Buttonv2
						loading={isMutating}
						onClick={onClickUnlock}
						variant="primary"
					>
						解除
					</Buttonv2>
				}
			/>
		</Modalv2>
	);
}
